var map = {
	"./back.svg": "c557",
	"./close.svg": "7710",
	"./exchange.svg": "7367",
	"./filter.svg": "c886",
	"./loading.svg": "d412",
	"./plus.svg": "2ece",
	"./right.svg": "9a71",
	"./success.svg": "a8cf",
	"./sync.svg": "3e1b",
	"./user.svg": "b3b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";